import type { FormLocale } from '@jlg-website/shared';
import { textFor } from './copy';

/** The one message both flows show when the endpoint refuses a booking. */
export function SubmitError({ locale }: { locale: FormLocale }) {
  return (
    <p role="alert" className="text-sm text-brand-accent-error">
      {textFor(locale, 'failed')}
    </p>
  );
}
